module.exports = __webpack_public_path__ + "static/media/acacia-office.ededf726.webp";